import { useCallback } from 'react'
import { useAppDispatch } from '@/store/hooks'
import { edgeUsersApi } from '@/services/api/users-api'

/**
 * Re-read the account's usage (the AI credits figure). A Deep Research run
 * reserves its credits on the server when it starts and hands them back when it
 * fails or is cancelled, through a different service than the usage query, so
 * nothing invalidated that query: the sidebar kept showing the figure from page
 * load. Its own hook so the page test can mock it without a store.
 */
export function useUsageRefresh(): () => void {
  const dispatch = useAppDispatch()
  return useCallback(() => {
    dispatch(edgeUsersApi.util.invalidateTags(['Usage']))
  }, [dispatch])
}
